<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="send-message"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_1005" data-name="Group 1005" transform="translate(3.5 3.503)">
      <path
        id="Path_8393"
        data-name="Path 8393"
        d="M5.39,12h5.49"
        transform="translate(4.23 -3.503)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8394"
        data-name="Path 8394"
        d="M18.759,3.63,4.167,10.924h0a1.2,1.2,0,0,0,0,2.151L18.759,20.37h0a1.2,1.2,0,0,0,1.7-1.384L18.609,12l1.85-6.986h0a1.2,1.2,0,0,0-1.7-1.384Z"
        transform="translate(-3.502 -3.503)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8395" data-name="Path 8395" d="M24,0H0V24H24Z" fill="none" />
  </svg>
</template>
